/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import GuideCharacter from '@assets/images/bg/character/betting-cancel.png'
import { CharacterDialog } from '@views/Popup/Dialog/CharacterDialog'

interface UserPenaltyInfoProps {
  penaltyMessage: string
}

export const UserPenaltyInfo: React.FC<UserPenaltyInfoProps> = observer((props: UserPenaltyInfoProps)  => {
  const { penaltyMessage } = props

  const penaltyMessageTxt = penaltyMessage

  const img = <img src={GuideCharacter} alt="캐릭터" className="guide-character" loading="lazy"/>
  const title = (
    <p className="guide-txt big">
      부적절한 게시물 또는 댓글을 작성하여<br/>
      <span className="point-color--orange--modal">제재되었습니다.</span>
    </p>
  )
  const body = (
    <div className="guide-box small">
      {penaltyMessageTxt}
    </div>
  )

  return (<CharacterDialog characterImg={img} title={title} body={body}/>)
})
